import React from 'react'
import { TaskPublishingButton } from 'components/CommonComponents/TaskPublishingOverlay'
import { ArrowLeft, ArrowRight, Check, ChevronLeft, ChevronRight } from 'lucide-react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'
import { Button, CloseButton } from 'components/ui'
import { useFormStepContext } from 'components/TasksV2/TaskCreation/FormStepContext'
import { AIStepType, useAILoadingContext } from '../AIFormStepContext'
import { useAiCreationText } from '../hooks/useAiCreationText'
import styles from './styles.module.css'

export function Header({
  onClose,
  actionSlot,
  promptReady,
}: {
  onClose: () => void
  promptReady: boolean
  actionSlot: (node: HTMLDivElement | null) => void
}) {
  const { stepStack, goToPreviousStep, sumbitStep, isMediaUploading } = useFormStepContext()
  const { isGenerating, isSubmitting } = useAILoadingContext()
  const rtl = useSelector(isRtlSelector)
  const t = useAiCreationText()
  const step = stepStack[stepStack.length - 1]
  const onboarding = step === AIStepType.AI_ONBOARDING
  const settings = step === AIStepType.AI_SETTINGS
  const preview = step === AIStepType.AI_SUBTASK
  const helper = step === AIStepType.AI_PROMPT_GENERATOR
  const number = preview ? 3 : settings ? 2 : 1
  const busy = isGenerating || isSubmitting || isMediaUploading

  return (
    <div className={styles.header} dir={rtl ? 'rtl' : 'ltr'}>
      {!onboarding && (settings || preview || helper) && (
        <Button type="button" variant="icon" aria-label={t.back} isDisabled={busy} onClick={goToPreviousStep}>
          {rtl ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </Button>
      )}
      <strong className={styles.title}>{t.title}</strong>
      {!onboarding && (
        <ol className={styles.steps}>
          {[t.prompt, t.assign, t.preview].map((label, index) => (
            <li key={index} aria-current={number === index + 1 ? 'step' : undefined} data-active={number >= index + 1}>
              <span>{number > index + 1 ? <Check size={12} /> : index + 1}</span>
              {label}
            </li>
          ))}
        </ol>
      )}
      <div ref={actionSlot} className={styles.action} />
      {isSubmitting && <TaskPublishingButton />}
      {!isSubmitting && !onboarding && !settings && !helper && (
        <Button
          type="button"
          height="36px"
          isDisabled={busy || (!preview && !promptReady)}
          onClick={sumbitStep}
          endIcon={preview ? undefined : rtl ? <ArrowLeft size={16} /> : <ArrowRight size={16} />}
        >
          {preview ? t.publish : t.next}
        </Button>
      )}
      <CloseButton type="button" aria-label={t.close} isDisabled={busy} onClick={onClose} />
    </div>
  )
}
